module.exports = __webpack_public_path__ + "img/conversation.1121cbfb.svg";